module.exports = __webpack_public_path__ + "cachable/img/3.7615d7da6d79973611a742d361255dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/patterns/3.png
// module id = 1192
// module chunks = 0